import Decimal from 'decimal.js';
import Numeric from '@/core/types/Numeric';
import Qty     from '@/core/types/Qty';
import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';

/**
 * Объём. Точность — 3 знака.
 *
 * Единица — КУБОМЕТРЫ (в базе колонка volume — numeric(6,3)).
 *
 * Округление — БЕЗУСЛОВНО ВВЕРХ (не half-up!): любой ненулевой хвост
 * поднимает третий знак. Грузовое место не может занять «чуть меньше»
 * места, чем его габариты — объём никогда не занижаем. ROUND_UP
 * гарантирует минимум 0.001 для любого ненулевого груза.
 * ROUND_UP = от нуля; отрицательный объём невозможен, так что от нуля
 * и к +∞ здесь совпадают. Зеркало на беке: RoundingMode::AwayFromZero.
 */
@Title_ru_RU_Class('Объём')
class Volume extends Numeric {
    static readonly SCALE = 3;
    protected static readonly ROUNDING: Decimal.Rounding = Decimal.ROUND_UP;

    static fromServer(value: string): Volume {
        return new Volume(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): Volume {
        return new Volume(value);
    }

    /** Объём места + объём места = суммарный объём. */
    plus(other: Volume | null | undefined): Volume {
        return Volume.fromOperation(this.value.plus(Volume.toDecimal(other)));
    }

    /** Объём (ед. груза) × количество = общий объём (паллетоместа). */
    mul(qty: Qty | null | undefined): Volume {
        return Volume.fromOperation(this.value.times(Volume.toDecimal(qty)));
    }

    /** Объём показываем со своим scale (дробь значима: 0.014 м³), но без
     * разделителей разрядов — это не денежная величина, группировка не нужна.
     * Пустое значение — пустая строка, не "NaN". */
    format(): string {
        if (this.isEmpty()) {
            return '';
        }

        return this.value.toFixed(this.scale);
    }
}

export default Volume;